module.exports = __webpack_public_path__ + "static/2_1_search-1_GA-fcfc5080b6af43dbe74f0445d0a1c313.svg";